export const translations = {
  uz: {
    nav_dashboard: "Asosiy",
    nav_emails: "Xatlar",
    nav_send: "Yuborish",
    nav_stats: "Statistika",
    nav_admin: "Admin",
    nav_mappings: "Ulanishlar",
    login_title: "Tizimga kirish",
    login_subtitle: "Davom etish uchun parolni kiriting",
    login_password_placeholder: "Parol...",
    login_button: "Kirish",
    login_checking: "Tekshirilmoqda...",
    login_error_wrong: "Noto'g'ri parol kiritdingiz",
    login_error_server: "Server bilan ulanishda xatolik yuz berdi",
    dashboard_title: "Mail Agent",
    dashboard_subtitle: "Korporativ pochta menejeri",
    dashboard_server: "Pochta serveri",
    dashboard_connected: "Ulangan",
    dashboard_disconnected: "Uzilgan",
    dashboard_last_check: "Oxirgi tekshiruv:",
    dashboard_check_mail: "Pochtani tekshirish",
    dashboard_checking: "Tekshirilmoqda...",
    dashboard_received: "Qabul",
    dashboard_received_desc: "xat qabul qilindi",
    dashboard_sent: "Yuborildi",
    dashboard_sent_desc: "xat yuborildi",
    dashboard_info_title: "Qisqacha ma'lumot",
    dashboard_info_server: "Pochta serveri",
    dashboard_info_user: "Foydalanuvchi",
    dashboard_info_interval: "Tekshirish oralig'i",
    dashboard_info_seconds: "soniya",
    dashboard_server_error: "Serverga ulanib bo'lmadi",
    emails_title: "Kiruvchi xatlar",
    emails_count: "ta xat",
    emails_empty: "Xatlar yo'q",
    emails_new: "Yangi",
    emails_attachment: "Fayl",
    email_detail_title: "Xat tafsilotlari",
    email_from: "Kimdan",
    email_date: "Sana",
    email_body_title: "Xat matni",
    email_body_empty: "Xat matni mavjud emas",
    email_attachments: "Ilovalar",
    email_reply_file: "Fayl bilan javob berish",
    send_title: "Fayl yuborish",
    send_drop_text: "Fayllarni bu yerga tashlang",
    send_drop_or: "yoki bosib tanlang",
    send_add_more: "+ Yana fayl qo'shish",
    send_recipient_label: "Qabul qiluvchi",
    send_recipient_placeholder: "email@example.com",
    send_button: "Yuborish",
    send_sending: "Yuborilmoqda...",
    send_loading: "Yuklanmoqda...",
    send_server_error: "Serverga ulanib bo'lmadi",
    stats_title: "Statistika",
    stats_received: "Qabul qilindi",
    stats_sent: "Yuborildi",
    stats_activity: "Faollik ko'rsatkichlari",
    stats_total: "Jami",
    stats_system_title: "Tizim holati",
    stats_server_status: "Server holati",
    stats_last_check: "Oxirgi tekshiruv",
    stats_daily_avg: "Kunlik o'rtacha",
    stats_per_day: "xat/kun",
    mappings_title: "Telegram Yo'naltirishlari",
    mappings_subtitle: "Email va Telegram Chat ID bog'lamalari",
    mappings_email: "Email Manzili",
    mappings_chat_id: "Telegram Chat ID",
    mappings_add: "Bog'lama qo'shish",
    mappings_delete: "O'chirish",
    mappings_no_data: "Hozircha hech qanday bog'lama yo'q",
    mappings_save: "Saqlash",
    mappings_placeholder_email: "masalan, user@nbu.uz",
    mappings_placeholder_chat_id: "masalan, 123456789",
    mappings_success_add: "Bog'lama muvaffaqiyatli qo'shildi",
    mappings_success_delete: "Bog'lama muvaffaqiyatli o'chirildi",
    mappings_error_invalid: "Email yoki Chat ID noto'g'ri",
    mappings_users_title: "Bot Foydalanuvchilari",
    mappings_users_subtitle: "Botni ishga tushirgan foydalanuvchilar",
    mappings_users_no_data: "Hozircha botda faol foydalanuvchilar yo'q",
    mappings_use_id: "Tanlash",
    admin_title: "Admin Panel",
    admin_tab_stats: "Statistika",
    admin_tab_archive: "Arxiv",
    admin_tab_block: "Bloklash",
    admin_tab_logs: "Loglar",
    admin_received: "Qabul",
    admin_sent: "Yuborildi",
    admin_system: "Tizim",
    admin_server: "Server",
    admin_last_check: "Oxirgi tekshiruv",
    admin_daily_avg: "Kunlik o'rtacha",
    admin_weekly: "Haftalik faollik",
    admin_no_files: "Yuborilgan fayllar hali yo'q",
    admin_blocked_title: "Bloklangan",
    admin_unblock: "Ochish",
    admin_users_title: "Foydalanuvchilar",
    admin_no_users: "Foydalanuvchilar yo'q",
    admin_block_btn: "Bloklash",
    admin_blocked_label: "Bloklangan",
    admin_logs_search: "Qidirish...",
    admin_logs_all: "Hammasi",
    admin_logs_empty: "Loglar topilmadi",
    email_mark_read: "O'qildi",
    email_archive: "Arxivlash",
    email_delete: "O'chirish",
    email_delete_confirm: "Bu xatni o'chirishni xohlaysizmi?",
    send_templates: "Shablonlar",
    send_no_templates: "Shablonlar yo'q",
    send_template_name: "Shablon nomi...",
    send_template_save: "Saqlash",
    lang_label: "Til",
  },
  ru: {
    nav_dashboard: "Главная",
    nav_emails: "Письма",
    nav_send: "Отправить",
    nav_stats: "Статистика",
    nav_admin: "Админ",
    nav_mappings: "Связки",
    login_title: "Вход в систему",
    login_subtitle: "Введите логин и пароль для продолжения",
    login_password_placeholder: "Пароль...",
    login_button: "Войти",
    login_checking: "Проверка...",
    login_error_wrong: "Неверный логин или пароль",
    login_error_server: "Ошибка подключения к серверу",
    dashboard_title: "Mail Agent",
    dashboard_subtitle: "Корпоративный менеджер почты",
    dashboard_server: "Почтовый сервер",
    dashboard_connected: "Подключен",
    dashboard_disconnected: "Отключен",
    dashboard_last_check: "Последняя проверка:",
    dashboard_check_mail: "Проверить почту",
    dashboard_checking: "Проверка...",
    dashboard_received: "Получено",
    dashboard_received_desc: "писем получено",
    dashboard_sent: "Отправлено",
    dashboard_sent_desc: "писем отправлено",
    dashboard_info_title: "Информация",
    dashboard_info_server: "Сервер почты",
    dashboard_info_user: "Пользователь",
    dashboard_info_interval: "Интервал проверки",
    dashboard_info_seconds: "секунд",
    dashboard_server_error: "Не удалось подключиться к серверу",
    emails_title: "Входящие письма",
    emails_count: "писем",
    emails_empty: "Нет писем",
    emails_new: "Новое",
    emails_attachment: "Файл",
    email_detail_title: "Детали письма",
    email_from: "От кого",
    email_date: "Дата",
    email_body_title: "Текст письма",
    email_body_empty: "Текст письма отсутствует",
    email_attachments: "Вложения",
    email_reply_file: "Ответить файлом",
    send_title: "Отправить файл",
    send_drop_text: "Перетащите файлы сюда",
    send_drop_or: "или нажмите для выбора",
    send_add_more: "+ Добавить файл",
    send_recipient_label: "Получатель",
    send_recipient_placeholder: "email@example.com",
    send_button: "Отправить",
    send_sending: "Отправка...",
    send_loading: "Загрузка...",
    send_server_error: "Не удалось подключиться к серверу",
    stats_title: "Статистика",
    stats_received: "Получено",
    stats_sent: "Отправлено",
    stats_activity: "Показатели активности",
    stats_total: "Всего",
    stats_system_title: "Состояние системы",
    stats_server_status: "Статус сервера",
    stats_last_check: "Последняя проверка",
    stats_daily_avg: "Среднее за день",
    stats_per_day: "писем/день",
    mappings_title: "Связки Telegram",
    mappings_subtitle: "Привязка Email к Telegram Chat ID",
    mappings_email: "Email адрес",
    mappings_chat_id: "Telegram Chat ID",
    mappings_add: "Добавить связку",
    mappings_delete: "Удалить",
    mappings_no_data: "Связок пока нет",
    mappings_save: "Сохранить",
    mappings_placeholder_email: "например, user@nbu.uz",
    mappings_placeholder_chat_id: "например, 123456789",
    mappings_success_add: "Связка успешно добавлена",
    mappings_success_delete: "Связка успешно удалена",
    mappings_error_invalid: "Неверный Email или Chat ID",
    mappings_users_title: "Пользователи бота",
    mappings_users_subtitle: "Пользователи, запустившие бота",
    mappings_users_no_data: "Активных пользователей пока нет",
    mappings_use_id: "Выбрать",
    admin_title: "Панель администратора",
    admin_tab_stats: "Статистика",
    admin_tab_archive: "Архив",
    admin_tab_block: "Блокировка",
    admin_tab_logs: "Логи",
    admin_received: "Получено",
    admin_sent: "Отправлено",
    admin_system: "Система",
    admin_server: "Сервер",
    admin_last_check: "Последняя проверка",
    admin_daily_avg: "Среднее за день",
    admin_weekly: "Активность за неделю",
    admin_no_files: "Отправленных файлов пока нет",
    admin_blocked_title: "Заблокированные",
    admin_unblock: "Разблокировать",
    admin_users_title: "Пользователи",
    admin_no_users: "Пользователей нет",
    admin_block_btn: "Заблокировать",
    admin_blocked_label: "Заблокирован",
    admin_logs_search: "Поиск...",
    admin_logs_all: "Все",
    admin_logs_empty: "Логи не найдены",
    email_mark_read: "Прочитано",
    email_archive: "Архивировать",
    email_delete: "Удалить",
    email_delete_confirm: "Вы уверены, что хотите удалить это письмо?",
    send_templates: "Шаблоны",
    send_no_templates: "Шаблонов нет",
    send_template_name: "Название шаблона...",
    send_template_save: "Сохранить",
    lang_label: "Язык",
  },
  en: {
    nav_dashboard: "Home",
    nav_emails: "Emails",
    nav_send: "Send",
    nav_stats: "Stats",
    nav_admin: "Admin",
    nav_mappings: "Mappings",
    login_title: "Sign In",
    login_subtitle: "Enter your credentials to continue",
    login_password_placeholder: "Password...",
    login_button: "Sign In",
    login_checking: "Checking...",
    login_error_wrong: "Invalid username or password",
    login_error_server: "Server connection error",
    dashboard_title: "Mail Agent",
    dashboard_subtitle: "Corporate mail manager",
    dashboard_server: "Mail Server",
    dashboard_connected: "Connected",
    dashboard_disconnected: "Disconnected",
    dashboard_last_check: "Last check:",
    dashboard_check_mail: "Check Mail",
    dashboard_checking: "Checking...",
    dashboard_received: "Received",
    dashboard_received_desc: "emails received",
    dashboard_sent: "Sent",
    dashboard_sent_desc: "emails sent",
    dashboard_info_title: "Information",
    dashboard_info_server: "Mail Server",
    dashboard_info_user: "User",
    dashboard_info_interval: "Check interval",
    dashboard_info_seconds: "seconds",
    dashboard_server_error: "Could not connect to server",
    emails_title: "Inbox",
    emails_count: "emails",
    emails_empty: "No emails",
    emails_new: "New",
    emails_attachment: "File",
    email_detail_title: "Email Details",
    email_from: "From",
    email_date: "Date",
    email_body_title: "Message",
    email_body_empty: "No message body",
    email_attachments: "Attachments",
    email_reply_file: "Reply with file",
    send_title: "Send File",
    send_drop_text: "Drop files here",
    send_drop_or: "or click to browse",
    send_add_more: "+ Add more files",
    send_recipient_label: "Recipient",
    send_recipient_placeholder: "email@example.com",
    send_button: "Send",
    send_sending: "Sending...",
    send_loading: "Loading...",
    send_server_error: "Could not connect to server",
    stats_title: "Statistics",
    stats_received: "Received",
    stats_sent: "Sent",
    stats_activity: "Activity metrics",
    stats_total: "Total",
    stats_system_title: "System Status",
    stats_server_status: "Server status",
    stats_last_check: "Last check",
    stats_daily_avg: "Daily average",
    stats_per_day: "emails/day",
    mappings_title: "Telegram Mappings",
    mappings_subtitle: "Email to Telegram Chat ID links",
    mappings_email: "Email Address",
    mappings_chat_id: "Telegram Chat ID",
    mappings_add: "Add mapping",
    mappings_delete: "Delete",
    mappings_no_data: "No mappings yet",
    mappings_save: "Save",
    mappings_placeholder_email: "e.g. user@nbu.uz",
    mappings_placeholder_chat_id: "e.g. 123456789",
    mappings_success_add: "Mapping added successfully",
    mappings_success_delete: "Mapping deleted successfully",
    mappings_error_invalid: "Invalid email or Chat ID",
    mappings_users_title: "Bot Users",
    mappings_users_subtitle: "Users who started the bot",
    mappings_users_no_data: "No active users yet",
    mappings_use_id: "Select",
    admin_title: "Admin Panel",
    admin_tab_stats: "Statistics",
    admin_tab_archive: "Archive",
    admin_tab_block: "Blocking",
    admin_tab_logs: "Logs",
    admin_received: "Received",
    admin_sent: "Sent",
    admin_system: "System",
    admin_server: "Server",
    admin_last_check: "Last check",
    admin_daily_avg: "Daily average",
    admin_weekly: "Weekly activity",
    admin_no_files: "No sent files yet",
    admin_blocked_title: "Blocked",
    admin_unblock: "Unblock",
    admin_users_title: "Users",
    admin_no_users: "No users",
    admin_block_btn: "Block",
    admin_blocked_label: "Blocked",
    admin_logs_search: "Search...",
    admin_logs_all: "All",
    admin_logs_empty: "No logs found",
    email_mark_read: "Mark read",
    email_archive: "Archive",
    email_delete: "Delete",
    email_delete_confirm: "Are you sure you want to delete this email?",
    send_templates: "Templates",
    send_no_templates: "No templates",
    send_template_name: "Template name...",
    send_template_save: "Save",
    lang_label: "Language",
  },
};
